export default <T>(array: T[], parts: number) => {
  const chunkArray: T[][] = []

  for (let i = parts; i > 0; i--) {
    chunkArray.push(array.splice(0, Math.ceil(array.length / i)))
  }

  return chunkArray
}
